export default __webpack_public_path__ + "static/media/arrowRightIcon.ae4047dc.svg";